import { gql } from "@apollo/client";

export const GET_STATS = gql`
  query GetStats {
    stats {
      timestamp

      # Bookings
      bookingsLast24Hours
      bookingsLast24HoursYoy
      bookingsLast7Days
      bookingsLast7DaysYoy
      bookingsLast30Days
      bookingsLast30DaysYoy
      bookingsMonthToDate
      bookingsMonthToDateLastYear
      bookingsMonthLastYearTotal
      
      # Quotes Sent
      quotesSentLast24Hours
      quotesSentLast24HoursYoy
      quotesSentLast7Days
      quotesSentLast7DaysYoy
      quotesSentLast30Days
      quotesSentLast30DaysYoy
      quotesSentMonthToDate
      quotesSentMonthToDateLastYear
      quotesSentMonthLastYearTotal
      
      # Closed Bookings
      closedBookingsLast24Hours
      closedBookingsLast24HoursYoy
      closedBookingsLast7Days
      closedBookingsLast7DaysYoy
      closedBookingsLast30Days
      closedBookingsLast30DaysYoy
      closedBookingsMonthToDate
      closedBookingsMonthToDateLastYear
      closedBookingsMonthLastYearTotal
      
      # Quote Rate
      quoteRateLast24Hours
      quoteRateLast24HoursYoy
      quoteRateLast7Days
      quoteRateLast7DaysYoy
      quoteRateLast30Days
      quoteRateLast30DaysYoy
      quoteRateMonthToDate
      quoteRateMonthToDateLastYear
      quoteRateMonthLastYearTotal
      
      # Close Rate
      closeRateLast24Hours
      closeRateLast24HoursYoy
      closeRateLast7Days
      closeRateLast7DaysYoy
      closeRateLast30Days
      closeRateLast30DaysYoy
      closeRateMonthToDate
      closeRateMonthToDateLastYear
      closeRateMonthLastYearTotal
    }
  }
`;
